import { useTranslation } from 'next-i18next';
import { AiGeneratingUI } from '../../AiGeneratingUI';
export const AiGenerateSingleAnswerOverlay = ({
  isAiGenerating
}: {
  isAiGenerating: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <AiGeneratingUI.SingleOption isVisible={isAiGenerating} data-sentry-element="unknown" data-sentry-component="AiGenerateSingleAnswerOverlay" data-sentry-source-file="AiGenerateSingleAnswerOverlay.tsx">
      {t('ai.generate.creatingAnswer')}
    </AiGeneratingUI.SingleOption>;
};